import { gameState } from "appworks/model/game-state";
import { Gameplay } from "appworks/model/gameplay/gameplay";
import { Exit } from "appworks/state-machine/data/exit";
import { Decision } from "appworks/state-machine/decisions/decision";
import { TGRInstantWinResult } from "integration/builders/results/tgr-instant-win-result";
import { FreespinRecord } from "slotworks/model/gameplay/records/freespin-record";
import { SpinRecord } from "slotworks/model/gameplay/records/spin-record";

export class IsTGRInstantWin extends Decision {

    public evaluate(): Exit {
        const gameplay: Gameplay = gameState.getCurrentGame();
        const instantWinResult: TGRInstantWinResult = gameplay.getCurrentRecord().getFirstResultOfType(TGRInstantWinResult);
        const shouldShowQuickhitResult = instantWinResult?.cashWon > 0 && (!gameState.currentRecordHasFreespinWinResults() || !this.allFreespinsPlayed());
        if (shouldShowQuickhitResult) {
            return Exit.True;
        }
        return Exit.False;
    }

    protected allFreespinsPlayed(): boolean {
        const currentGame: Gameplay = gameState.getCurrentGame();
        const record: SpinRecord | FreespinRecord = currentGame.getCurrentRecord() as SpinRecord | FreespinRecord;
        if (record.currentChildIndex === currentGame.getTotalFreespinsWon() - 1) {
            return true;
        }
        return false;
    }
}
